import { Theme } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles<Theme>(theme => ({
  block: {
    height: '100%',
    width: '100%',
  },
  blue400: {
    color: theme.palette.common.blue400,
  },
  fullScreen: {
    background: 'rgba(0, 0, 0, 0.1)',
    bottom: 0,
    left: 0,
    position: 'fixed',
    top: 0,
    zIndex: theme.zIndex.loader,
  },
  fullSection: {
    height: '100%',
    width: '100%',
    zIndex: theme.zIndex.loader,
  },
  gray200: {
    color: theme.palette.common.gray200,
  },
  gray400: {
    color: theme.palette.common.gray200,
  },
  gray600: {
    color: theme.palette.common.gray200,
  },
  gray800: {
    color: theme.palette.common.gray200,
  },
  white: {
    color: theme.palette.common.white,
  },
}));

export default useStyles;
